module.exports = __webpack_public_path__ + "img/icon_features_1.1b6c50de.png";